/** Единые русские подписи отделов для operational UI (Phase S). */
export const OPERATIONAL_DEPARTMENT_LABELS: Record<string, string> = {
  FINANCE: 'Финансы',
  DISPATCH: 'Диспетчеризация',
  DOCUMENTS: 'Документы',
  OPERATIONS: 'Операции'
};

export function operationalDepartmentLabel(code: string | null | undefined): string {
  if (!code) return 'Операции';
  return OPERATIONAL_DEPARTMENT_LABELS[code] ?? code;
}
